import _ from 'lodash';

export const checkIfShouldBePollingScrapeRequest = state =>
  _.get(state, 'pages.dashboard.pollScrapeRequest', false);
